import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartType, ChartOptions } from 'chart.js';
import { MasterService } from '../../../@core/services/master.service';

@Component({
  selector: 'ngx-analysis-manager',
  templateUrl: './analysis-manager.component.html',
  styleUrls: ['./analysis-manager.component.scss']
})
export class AnalysisManagerComponent {
   constructor(private f_builder: FormBuilder,
               private router: Router,
               private modalService: NgbModal,
               private masterService: MasterService,
               private notify: NbToastrService,
               ) { }
  // Bar Chart
barChartData = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      data: [12, 19, 3, 5, 2, 3],
      label: 'Dataset 1',
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
      borderColor: 'rgba(75, 192, 192, 1)',
      borderWidth: 1,
    },
  ],
};
barChartType: ChartType = 'bar';

// Doughnut Chart
doughnutChartData = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      data: [15, 25, 30, 10, 5, 15],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};
doughnutChartType: ChartType = 'doughnut';

// Pie Chart
pieChartData = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      data: [10, 20, 30, 15, 25, 5],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};
pieChartType: ChartType = 'pie';

// Polar Area Chart
polarAreaChartData = {
  labels: ['Red', 'Green', 'Blue', 'Yellow', 'Purple'],
  datasets: [
    {
      data: [11, 16, 7, 3, 14],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
      ],
      borderWidth: 1,
    },
  ],
};
polarAreaChartType: ChartType = 'polarArea';

// Shared Options
chartOptions: ChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    tooltip: {
      enabled: true,
    },
  },
};

chartLegend = true;

// Conditional chart rendering
showBarChart = true;
showDoughnutChart = true;
showPieChart = true;
showPolarAreaChart = true;

home() {
  this.router.navigate(['/dashboard-manager'])
}
}